/*
 * Fix: Coupon-Guard (verhindert TypeError, wenn .coupon-both-section fehlt).
 */
/*
 * Laedt custom-ux.css (mobile UX-Overrides + Free-Shipping-Balken-Styling).
 * Hinweis: bei Aenderungen an custom-ux.css auch custom.js neu speichern
 * (Build-Nummer erhoehen), damit der ?v-Cache-Buster greift.
 * ux-build: 16
 */
(function () {
  var self = document.currentScript;
  function addLink(href) {
    try {
      if (!href || document.querySelector('link[href*="custom-ux.css"]')) return;
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      (document.head || document.documentElement).appendChild(l);
    } catch (e) { /* no-op */ }
  }
  try {
    if (self && self.src && self.src.indexOf('custom.js') !== -1) {
      addLink(self.src.replace('custom.js', 'custom-ux.css'));
      return;
    }
  } catch (e) { /* no-op */ }
  document.addEventListener('DOMContentLoaded', function () {
    try {
      var ref = document.querySelector('link[href*="/custom.css"]');
      if (ref) addLink(ref.getAttribute('href').replace('custom.css', 'custom-ux.css'));
    } catch (e) { /* no-op */ }
  });
})();

(function () {
  function ensureCouponSection() {
    try {
      if (!document.querySelector('.coupon-both-section')) {
        var placeholder = document.createElement('div');
        placeholder.className = 'coupon-both-section';
        placeholder.setAttribute('data-coupon-placeholder', 'true');
        placeholder.style.display = 'none';
        (document.body || document.documentElement).appendChild(placeholder);
      }
    } catch (e) { /* no-op */ }
  }
  if (document.body) {
    ensureCouponSection();
  } else {
    document.addEventListener('DOMContentLoaded', ensureCouponSection);
  }
})();

/*
 * Performance: "ss_product_videos"-Galerie -> Autoplay entfernen, preload=metadata,
 * controls; ueberdimensionierte Thumbnails per &width verkleinern. */
(function () {
  var VIDEO_SCOPE = '[class*="ss_product_videos"], [class*="video-modal"], [class*="video-slider"], [class*="video-slide"]';

  function tameVideo(v) {
    try {
      if (!v || v.getAttribute('data-perf-tamed')) return;
      if (!v.closest(VIDEO_SCOPE)) return;
      v.setAttribute('data-perf-tamed', '1');
      v.autoplay = false;
      v.removeAttribute('autoplay');
      v.setAttribute('preload', 'metadata');
      if (!v.hasAttribute('controls')) v.setAttribute('controls', '');
      if (v.pause) { try { v.pause(); } catch (e) {} }
    } catch (e) { /* no-op */ }
  }

  function shrinkThumb(img) {
    try {
      if (!img || img.getAttribute('data-perf-sized')) return;
      if (!img.closest(VIDEO_SCOPE)) return;
      var src = img.getAttribute('src') || '';
      if (!/\/cdn\/shop\//.test(src)) return;
      if (/[?&]width=/.test(src)) { img.setAttribute('data-perf-sized', '1'); return; }
      img.setAttribute('data-perf-sized', '1');
      img.setAttribute('src', src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=400');
    } catch (e) { /* no-op */ }
  }

  function scan(root) {
    try {
      var r = root && root.querySelectorAll ? root : document;
      r.querySelectorAll('video').forEach(tameVideo);
      r.querySelectorAll('img').forEach(shrinkThumb);
    } catch (e) { /* no-op */ }
  }

  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.tagName === 'VIDEO') tameVideo(n);
          else if (n.tagName === 'IMG') shrinkThumb(n);
          else scan(n);
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('load', function () {
      setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 2500);
    });
  } catch (e) { /* no-op */ }

  document.addEventListener('DOMContentLoaded', function () { scan(document); });
})();

/*
 * Free-Shipping-Balken: Snippet berechnet Schwelle falsch (times:75 statt times:100).
 * Skript liest die falsche Schwelle aus threshold, rechnet korrekt hoch (x100/75) und
 * aktualisiert Fortschritt, Text und .fsb-complete anhand der ECHTEN Warenkorbsumme.
 * Zeigt bei Mengenaenderungen nie einen falschen Zwischenbetrag: haelt den letzten
 * korrekten Wert und aktualisiert erst, wenn die Summe stabil ist (Salepify-Rabatt
 * verrechnet, ~0,5-0,7s). Verhindert das kurze "Umspringen" des Betrags.
 */
(function () {
  function eur(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  var fsbCache = null;   // letzter STABILER Zustand {remaining, complete, progress}
  var fsbTimer = null;
  function render(state) {
    try {
      var bar = document.querySelector('free-shipping-bar');
      if (!bar || !state) return;
      bar.style.setProperty('--progress', state.complete ? 1 : state.progress);
      bar.classList.toggle('fsb-complete', state.complete);
      var t = bar.querySelector('.shipping-bar__text');
      if (t) t.textContent = state.complete
        ? 'Du hast kostenlosen Versand freigeschaltet (DE)! '
        : 'Dir fehlen nur noch ' + eur(state.remaining) + ' zum kostenlosen Versand (DE). ';
    } catch (e) { /* no-op */ }
  }
  function compute(totalCents, correct) {
    var remaining = correct - totalCents;
    var complete = remaining <= 0;
    return { remaining: remaining, complete: complete, progress: complete ? 1 : (totalCents / correct) };
  }
  // Wartet, bis der Warenkorb STABIL ist. Salepify verrechnet den Mengenrabatt erst
  // ~0,5-0,7s nach einer Mengenaenderung; bis dahin liefert /cart.js die noch
  // unrabattierte Summe. Erst wenn sich die Summe nicht mehr aendert, wird angezeigt.
  function settle(correct) {
    clearTimeout(fsbTimer);
    var start = Date.now();
    var prev = null;
    function step() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var total = c.total_price;
          var elapsed = Date.now() - start;
          if ((prev === total && elapsed >= 700) || elapsed >= 2500) {
            fsbCache = compute(total, correct);
            render(fsbCache);
          } else {
            prev = total;
            fsbTimer = setTimeout(step, 300);
          }
        })
        .catch(function () {});
    }
    fsbTimer = setTimeout(step, 300);
  }
  function fix(bar) {
    try {
      var buggy = parseInt(bar.getAttribute('threshold'), 10);
      if (!buggy) return;
      // times:75-Bug im Snippet -> echte Schwelle (z.B. 5625 -> 7500 = 75 EUR).
      var correct = Math.round(buggy * 100 / 75);
      if (fsbCache) {
        // Letzten KORREKTEN Wert HALTEN, statt den noch unrabattierten Zwischenstand
        // direkt nach der Mengenaenderung (falscher Betrag fuer ~1s) zu zeigen.
        render(fsbCache);
      } else {
        // Erstanzeige: Warenkorb ist beim Oeffnen stabil -> einmal direkt holen.
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { fsbCache = compute(c.total_price, correct); render(fsbCache); })
          .catch(function () {});
      }
      settle(correct); // massgeblicher Wert, sobald der Rabatt verrechnet ist
    } catch (e) { /* no-op */ }
  }
  function scanBars(node) {
    try {
      if (node.tagName === 'FREE-SHIPPING-BAR') fix(node);
      if (node.querySelectorAll) node.querySelectorAll('free-shipping-bar').forEach(fix);
    } catch (e) { /* no-op */ }
  }
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          if (nodes[j].nodeType === 1) scanBars(nodes[j]);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) { /* no-op */ }
  document.addEventListener('DOMContentLoaded', function () { scanBars(document); });
})();

/*
 * Mobil: kurzes Kategorie-Label statt des langen Produkttitels in der Sticky-Leiste.
 * Kategorie wird aus ShopifyAnalytics-Produkt-Typ + Handle abgeleitet (Collections sind
 * clientseitig nicht lesbar). Reihenfolge wichtig (buddy/strap vor "Set"). Faellt auf
 * den Produkttitel zurueck, wenn keine Kategorie passt. Anzeige steuert custom-ux.css.
 */
(function () {
  function catLabel() {
    try {
      var p = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) || {};
      var t = (p.type || '').toLowerCase();
      var h = (location.pathname.split('/products/')[1] || '').split(/[/?]/)[0].toLowerCase();
      var s = t + ' ' + h;
      if (/rucksack|backpack/.test(s)) return 'Cool Backpack';
      if (/tritan/.test(h) || /weingl(ä|ae)ser/.test(t)) return 'Tritan Weinglas';
      if (/buddy/.test(h)) return 'Buddy';
      if (/strap|kette/.test(h)) return 'Strap/Kette';
      if (/weinglashalter/.test(s) || /(^|[-_])set([-_]|$)/.test(h) || /bundle|mit-glas/.test(h)) return 'Set';
      return null;
    } catch (e) { return null; }
  }
  function applyLabel() {
    try {
      var form = document.querySelector('product-sticky-form');
      if (!form || form.getAttribute('data-cat-label-done')) return;
      var info = form.querySelector('.product-sticky-info');
      if (!info) return;
      var lab = catLabel();
      if (!lab) return;
      form.setAttribute('data-cat-label-done', '1');
      var span = document.createElement('span');
      span.className = 'pst-cat-label';
      span.textContent = lab;
      info.insertBefore(span, info.firstChild);
      form.classList.add('has-cat-label');
    } catch (e) { /* no-op */ }
  }
  if (document.readyState !== 'loading') applyLabel();
  document.addEventListener('DOMContentLoaded', applyLabel);
})();

jQuery( document ).ready(function($) {
     $('.list-menu__item span').click(function(){
       $(this).closest('.list-menu__item').toggleClass('active_item');
    })


  $('.annouce-slider').flickity({
  contain: true,
  pageDots: false,
prevNextButtons: false,
    autoPlay: 5000 ,
    wrapAround: true
});
  var $backToTop = $(".back-to-top");
  $backToTop.hide();

  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
      $backToTop.fadeIn();
    } else {
      $backToTop.fadeOut();
    }
  });

  $backToTop.on('click', function(e) {
    $("html, body").animate({scrollTop: 0}, 500);
  });

  $('.product-grid-container').addClass('grid-view-section');
    $('.grid-view').click(function() {
        $(this).addClass('active');
        $('.list-view').removeClass('active');
        $('.product-grid-container').removeClass('list-view-section1').addClass('grid-view-section');
        $('#product-grid').removeClass('grid--4-col-desktop grid--2-col-tablet-down').addClass('grid--2-col-desktop grid--1-col-tablet-down');
    });

    $('.list-view').click(function() {
        $(this).addClass('active');
        $('.grid-view').removeClass('active');
        $('.product-grid-container').removeClass('grid-view-section1').addClass('list-view-section1');
        $('#product-grid').removeClass('grid--2-col-desktop grid--1-col-tablet-down').addClass('grid--4-col-desktop grid--2-col-tablet-down');

    });
  });




document.addEventListener("DOMContentLoaded", function () {
  const stickyForm = document.querySelector("product-sticky-form");
  const footer = document.querySelector("footer");

  if (stickyForm && footer) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyForm.style.display = "none";
          } else {
            stickyForm.style.display = "";
          }
        });
      },
      {
        root: null,
        threshold: 0,
      }
    );

    observer.observe(footer);
  }
});
